/**
 * @param memberships user memberships taken from user state (organizationId_membershipStatus)
 * @param orgId membership you are searching for
 * */
export function getUserMembershipStatus(memberships, orgId) {
    const membership = memberships.find((membership) => {
        const membershipOrgId = membership.split('_')[0];
        return membershipOrgId == orgId;
    });
    if (!membership) {
        return undefined;
    }
    const membershipStatus = membership.split('_')[1];
    if (membershipStatus === 'accepted') {
        return 'joined';
    }
    else if (membershipStatus === 'pending') {
        return 'pending';
    }
    else {
        return undefined;
    }
}
